import { render, staticRenderFns } from "./OrderStatusTrend.vue?vue&type=template&id=58a6b28f"
import script from "./OrderStatusTrend.vue?vue&type=script&lang=js"
export * from "./OrderStatusTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports